module.exports = __webpack_public_path__ + "assets/img/wechat.01a54f66.jpg";